// // import React from "react";
// // import { Container, Grid, Typography, Box, Card, Avatar } from "@mui/material";
// // import { useNavigate } from "react-router-dom";
// // import { styled } from "@mui/material/styles";
// // import Header from "./Header"; // Common Header Component
// // import Footer from "./Footer"; // Common Footer Component

// // // Importing Images
// // import heroBg from "../assets/heroBg.jpeg";
// // import heroBg1 from "../assets/heroBg1.jpeg";
// // import image from "../assets/image.png";
// // import image2 from "../assets/image2.png.jpg";

// // // Services Data
// // const services = [
// //   { title: "Custom Software", img: heroBg },
// //   { title: "AI & Automation", img: heroBg1 },
// //   { title: "AR/VR Applications", img: image },
// //   { title: "UI/UX Design", img: image2 },
// // ];

// // // Testimonials Data
// // const testimonials = [
// //   {
// //     name: "John Doe",
// //     feedback:
// //       "Willovate transformed our business with a cutting-edge AI system!",
// //     img: "/assets/user1.jpg",
// //   },
// //   {
// //     name: "Emily Smith",
// //     feedback:
// //       "The team delivered a custom web app that exceeded our expectations!",
// //     img: "/assets/user2.jpg",
// //   },
// // ];

// // // Styled Button
// // const GradientButton = styled("button")({
// //   marginTop: "20px",
// //   padding: "12px 30px",
// //   fontSize: "1.2rem",
// //   fontWeight: "bold",
// //   color: "#fff",
// //   background: "linear-gradient(90deg, #84F4EE, #2DEB9C)",
// //   border: "none",
// //   borderRadius: "30px",
// //   cursor: "pointer",
// //   transition: "transform 0.3s ease, box-shadow 0.3s ease",
// //   "&:hover": {
// //     transform: "scale(1.05)",
// //     boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
// //   },
// // });

// // const ExploreMore = () => {
// //   const navigate = useNavigate();

// //   return (
// //     <Box>
// //       <Header /> {/* Common Header Component */}
// //       {/* Hero Section with Background Image */}
// //       <Box
// //         sx={{
// //           position: "relative",
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           height: { xs: "220px", md: "100px" },
// //           textAlign: "center",
// //           overflow: "hidden",
// //           mt: { xs: 7, md: 8 },
// //         }}
// //       >
// //         {/* Background Image */}
// //         <Box
// //           sx={{
// //             position: "absolute",
// //             top: 0,
// //             left: 0,
// //             transform: "translate(-50%, -50%)",
// //             width: "100%",
// //             height: "100%",
// //             backgroundSize: "cover",
// //             backgroundPosition: "center",
// //             backgroundRepeat: "no-repeat",
// //             filter: "brightness(50%)",
// //             zIndex: -1,
// //           }}
// //         />

// //         {/* Text Content */}
// //         <Typography
// //           variant="h2"
// //           fontWeight="bold"
// //           sx={{ color: "#000ca4", zIndex: 1 }}
// //         >
// //           IT Consultancy
// //         </Typography>
// //       </Box>
// //       {/* Services Section */}
// //       <Container
// //         width="100%"
// //         maxWidth="100%"
// //         sx={{ textAlign: "center", backgroundColor: "#fff", py: 10 }}
// //       >
// //         <Grid
// //           container
// //           spacing={4}
// //           justifyContent="center"
// //           alignItems="stretch"
// //         >
// //           {services.map((item, index) => (
// //             <Grid item xs={12} sm={6} md={3} key={index}>
// //               <Box
// //                 sx={{
// //                   width: "100%",
// //                   display: "flex",
// //                   flexDirection: "column",
// //                   alignItems: "center",
// //                   justifyContent: "space-between",
// //                   backgroundColor: "#fff",
// //                   borderRadius: "12px",
// //                   boxShadow: "0 4px 12px rgba(45, 92, 235, 0.58)",
// //                   textAlign: "center",
// //                   transition: "0.3s",
// //                   height: "100%",
// //                   border: "1px solid #e0e0e0",
// //                   minHeight: "340px", // Adjust card height
// //                   "&:hover": {
// //                     transform: "scale(1.05)",
// //                     boxShadow: "0 6px 18px rgb(45, 235, 156, 0.9)",
// //                     border: "1px solid #2DEB9C",
// //                   },
// //                 }}
// //               >
// //                 {/* Image Box with Centered Title */}
// //                 <Box
// //                   sx={{
// //                     position: "relative",
// //                     textAlign: "center",
// //                     width: "100%",
// //                   }}
// //                 >
// //                   <Box
// //                     component="img"
// //                     src={item.img}
// //                     alt={item.title}
// //                     sx={{
// //                       width: "100%",
// //                       height: "200px",
// //                       objectFit: "cover",
// //                       borderRadius: "10px 10px 0 0",
// //                     }}
// //                   />

// //                   <Typography
// //                     variant="h5"
// //                     fontWeight="600"
// //                     sx={{
// //                       width: "100%",
// //                       maxWidth: "400px",
// //                       mt: 5,
// //                       px: 0,
// //                       mb: 2,
// //                       color: "#333",
// //                       textAlign: "center",
// //                       fontFamily: "Poppins, sans-serif",
// //                     }}
// //                   >
// //                     {item.title}
// //                   </Typography>
// //                 </Box>
// //               </Box>
// //             </Grid>
// //           ))}
// //         </Grid>
// //       </Container>
// //       {/* Testimonials Section */}
// //       <Box
// //         sx={{
// //           background:
// //             "linear-gradient(to right, rgba(45, 92, 235, 1), rgb(45, 235, 156))",
// //           py: 12,
// //         }}
// //       >
// //         <Container maxWidth="lg">
// //           <Typography
// //             variant="h3"
// //             fontWeight="bold"
// //             textAlign="center"
// //             mb={5}
// //             sx={{ color: "#fff" }}
// //           >
// //             What Our Clients Say
// //           </Typography>

// //           <Grid container spacing={4} justifyContent="center">
// //             {testimonials.map((client, index) => (
// //               <Grid item xs={12} sm={6} md={4} key={index}>
// //                 <Card
// //                   sx={{
// //                     padding: "30px",
// //                     textAlign: "center",
// //                     borderRadius: "10px",
// //                     boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
// //                   }}
// //                 >
// //                   <Avatar
// //                     src={client.img}
// //                     sx={{ width: 80, height: 80, margin: "auto" }}
// //                   />

// //                   <Typography variant="h5" fontWeight="bold" mt={2} mb={2}>
// //                     {client.name}
// //                   </Typography>

// //                   <Typography variant="body2" color="textSecondary">
// //                     "{client.feedback}"
// //                   </Typography>
// //                 </Card>
// //               </Grid>
// //             ))}
// //           </Grid>
// //         </Container>
// //       </Box>
// //       {/* Call to Action */}
// //       <Box sx={{ textAlign: "center", backgroundColor: "#fff", py: 18 }}>
// //         <Typography variant="h2" fontWeight="bold" color="black" mb={5}>
// //           Have an idea? Let’s build it together!
// //         </Typography>

// //         <GradientButton onClick={() => navigate("/contact")}>
// //           Start Your Project
// //         </GradientButton>
// //       </Box>
// //       <Footer /> {/* Common Footer Component */}
// //     </Box>
// //   );
// // };

// // export default ExploreMore;

// import React from "react";
// import {
//   Container,
//   Grid,
//   Typography,
//   Box,
//   Card,
//   Avatar,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { styled } from "@mui/material/styles";
// import Header from "./Header";
// import Footer from "./Footer";

// // Images
// import heroBg from "../assets/heroBg.jpeg";
// import heroBg1 from "../assets/heroBg1.jpeg";
// import image from "../assets/image.png";
// import image2 from "../assets/image2.png.jpg";

// // Services Data
// const services = [
//   {
//     title: "Custom Software",
//     img: heroBg,
//     description: "Tailored solutions for your unique business needs",
//   },
//   {
//     title: "AI & Automation",
//     img: heroBg1,
//     description: "Smart systems to streamline your operations",
//   },
//   {
//     title: "AR/VR Applications",
//     img: image,
//     description: "Immersive experiences for your customers",
//   },
//   {
//     title: "UI/UX Design",
//     img: image2,
//     description: "Beautiful interfaces that drive engagement",
//   },
// ];

// // Testimonials Data
// const testimonials = [
//   {
//     name: "John Doe",
//     feedback: "Willovate transformed our business with cutting-edge AI!",
//     img: "/assets/user1.jpg",
//     role: "CEO, TechCorp",
//   },
//   {
//     name: "Emily Smith",
//     feedback: "The team delivered a custom web app that exceeded expectations!",
//     img: "/assets/user2.jpg",
//     role: "CTO, InnovateX",
//   },
// ];

// // Styled Components
// const GradientButton = styled("button")(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: "12px 30px",
//   fontSize: "1rem",
//   fontWeight: 600,
//   color: "#fff",
//   background: "linear-gradient(90deg, #84F4EE, #2DEB9C)",
//   border: "none",
//   borderRadius: "30px",
//   cursor: "pointer",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     transform: "scale(1.05)",
//     boxShadow: "0 4px 15px rgba(45, 235, 156, 0.4)",
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: "10px 24px",
//     fontSize: "0.9rem",
//   },
// }));

// const ServiceCard = styled(Card)(({ theme }) => ({
//   height: "100%",
//   display: "flex",
//   flexDirection: "column",
//   borderRadius: "12px",
//   overflow: "hidden",
//   transition: "all 0.3s ease",
//   boxShadow: theme.shadows[4],
//   "&:hover": {
//     transform: "translateY(-8px)",
//     boxShadow: theme.shadows[8],
//     "& .service-image": {
//       transform: "scale(1.05)",
//     },
//   },
// }));

// const ExploreMore = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   return (
//     <Box sx={{ overflowX: "hidden" }}>
//       <Header />

//       {/* Hero Section */}
//       <Box
//         sx={{
//           position: "relative",
//           height: isMobile ? "200px" : "300px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: "#f5f7ff",
//           mt: { xs: 7, md: 8 },
//           mb: 6,
//         }}
//       >
//         <Typography
//           variant={isMobile ? "h3" : "h2"}
//           fontWeight="bold"
//           sx={{
//             color: "#000ca4",
//             textAlign: "center",
//             px: 2,
//             zIndex: 1,
//           }}
//         >
//           IT Consultancy Services
//         </Typography>
//       </Box>

//       {/* Services Section */}
//       <Container maxWidth="lg" sx={{ py: 8 }}>
//         <Typography
//           variant="h4"
//           fontWeight="bold"
//           textAlign="center"
//           mb={6}
//           sx={{ color: "#000ca4" }}
//         >
//           Our Expertise
//         </Typography>

//         <Grid container spacing={4}>
//           {services.map((item, index) => (
//             <Grid item xs={12} sm={6} md={3} key={index}>
//               <ServiceCard>
//                 <Box
//                   className="service-image"
//                   sx={{
//                     height: "180px",
//                     overflow: "hidden",
//                     transition: "transform 0.5s ease",
//                   }}
//                 >
//                   <img
//                     src={item.img}
//                     alt={item.title}
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 </Box>
//                 <Box sx={{ p: 3 }}>
//                   <Typography
//                     variant="h6"
//                     fontWeight="600"
//                     gutterBottom
//                     sx={{ color: "#000ca4" }}
//                   >
//                     {item.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {item.description}
//                   </Typography>
//                 </Box>
//               </ServiceCard>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>

//       {/* Testimonials Section */}
//       <Box
//         sx={{
//           background: "linear-gradient(135deg, #2D5CEB 0%, #2DEB9C 100%)",
//           py: 10,
//           color: "white",
//         }}
//       >
//         <Container maxWidth="lg">
//           <Typography variant="h4" fontWeight="bold" textAlign="center" mb={6}>
//             Client Testimonials
//           </Typography>

//           <Grid container spacing={4} justifyContent="center">
//             {testimonials.map((client, index) => (
//               <Grid item xs={12} md={6} key={index}>
//                 <Card
//                   sx={{
//                     p: 4,
//                     borderRadius: "12px",
//                     boxShadow: 3,
//                     height: "100%",
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
//                     <Avatar
//                       src={client.img}
//                       sx={{
//                         width: 60,
//                         height: 60,
//                         mr: 2,
//                       }}
//                     />
//                     <Box>
//                       <Typography variant="h6" fontWeight="bold">
//                         {client.name}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         {client.role}
//                       </Typography>
//                     </Box>
//                   </Box>
//                   <Typography variant="body1" fontStyle="italic">
//                     "{client.feedback}"
//                   </Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* CTA Section */}
//       <Container maxWidth="md" sx={{ py: 12, textAlign: "center" }}>
//         <Typography
//           variant={isMobile ? "h4" : "h3"}
//           fontWeight="bold"
//           mb={4}
//           sx={{ color: "#000ca4" }}
//         >
//           Ready to Transform Your Business?
//         </Typography>
//         <Typography variant="body1" mb={4} color="text.secondary">
//           Let's discuss how our IT consultancy services can help you achieve
//           your goals.
//         </Typography>
//         <GradientButton onClick={() => navigate("/contact")}>
//           Get Started Today
//         </GradientButton>
//       </Container>

//       <Footer />
//     </Box>
//   );
// };

// export default ExploreMore;

import React from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  Card,
  Avatar,
  Chip,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";

// Icons (Install @mui/icons-material if not already)
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CodeIcon from "@mui/icons-material/Code"; // Replacement for TerminalIcon
import SmartToyIcon from "@mui/icons-material/SmartToy"; // Replacement for AI icon
import ViewInArIcon from "@mui/icons-material/ViewInAr"; // Replacement for VR icon
import PaletteIcon from "@mui/icons-material/Palette"; // Replacement for Design icon

// Images
import heroBg from "../assets/heroBg.jpeg";

// Styled Components
const GlowCard = styled(Card)(({ theme }) => ({
  height: "100%",
  border: "1px solid rgba(45, 235, 156, 0.3)",
  background: "rgba(255, 255, 255, 0.05)",
  backdropFilter: "blur(10px)",
  transition: "all 0.4s ease",
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: `0 15px 30px -5px rgba(45, 235, 156, 0.3)`,
    borderColor: "rgba(45, 235, 156, 0.6)",
  },
}));

const services = [
  {
    title: "Strategic IT Consulting",
    icon: <CodeIcon color="primary" sx={{ fontSize: 50 }} />,
    highlights: [
      "Digital transformation roadmap",
      "Technology stack evaluation",
      "Cost optimization strategies",
    ],
  },
  {
    title: "AI Solutions",
    icon: <SmartToyIcon color="primary" sx={{ fontSize: 50 }} />,
    highlights: [
      "Custom AI models",
      "Process automation",
      "Predictive analytics",
    ],
  },
  {
    title: "Emerging Tech",
    icon: <ViewInArIcon color="primary" sx={{ fontSize: 50 }} />,
    highlights: [
      "AR/VR development",
      "IoT integration",
      "Blockchain solutions",
    ],
  },
  {
    title: "Experience Design",
    icon: <PaletteIcon color="primary" sx={{ fontSize: 50 }} />,
    highlights: [
      "User-centric interfaces",
      "Conversion optimization",
      "Accessibility compliance",
    ],
  },
];

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "CTO at FinTech Global",
    feedback:
      "Reduced our operational costs by 40% while improving system reliability",
    avatar: "/assets/avatar1.jpg",
  },
  {
    name: "Raj Patel",
    role: "CEO at HealthInnovate",
    feedback:
      "Their AI solution helped us process 10,000+ patient records daily with 99.9% accuracy",
    avatar: "/assets/avatar2.jpg",
  },
];

const ViewMore = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  return (
    <Box sx={{ background: "#f9fbfe" }}>

      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: `linear-gradient(rgba(0, 12, 164, 0.7), rgba(0, 12, 164, 0.7)), url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "black",
          py: 15,
          textAlign: "center",
        }}
      >
        <Container maxWidth="lg">
          <Chip
            label="TRUSTED BY FORTUNE COMPANIES"
            color="primary"
            sx={{
              mb: 4,
              px: 2,
              py: 1,
              fontWeight: "bold",
              backgroundColor: "#2DEB9C",
              color: "black",
            }}
          />
          <Typography
            variant={isMobile ? "h4" : "h2"}
            fontWeight="bold" color="white"
            gutterBottom
          >
            Transform Your Business With{" "}
            <span style={{ color: "#2DEB9C" }}>Expert IT Guidance</span>
          </Typography>

          <Typography variant="h6" sx={{ maxWidth: 800, mx: "auto", mb: 5, color:"#ffff" }}>
            We don't just implement technology - we align it with your business
            goals for measurable impact
          </Typography>

          <Button
            variant="contained"
            size="large"
            sx={{
              background: "linear-gradient(90deg, #2DEB9C, #2D5CEB)",
              borderRadius: "30px",
              px: 5,
              fontWeight: "bold",
              mt: 2,
            }}
            onClick={() => navigate("/contact")}
          >
            Get Free Consultation
          </Button>
        </Container>
      </Box>

      {/* Services Section */}
      <Container maxWidth="lg" sx={{ py: 10 }}>
        <Typography
          variant="h2"
          fontWeight="bold"
          textAlign="center"
          sx={{ color: "#000ca4", mb: 2 }}
        >
          Our IT Consulting Services
        </Typography>
        <Typography
          variant="h6"
          align="center"
          sx={{ maxWidth: 700, mx: "auto", mb: 6, color: "text.secondary" }}
        >
          We deliver measurable business outcomes through technology innovation
        </Typography>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <GlowCard sx={{ p: 3, height: "100%", maxHeight: "250px" }}>
                <Box textAlign="center" sx={{ mb: 3 }}>
                  {service.icon}
                </Box>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  textAlign="center"
                  marginBottom={3.5}
                  gutterBottom
                >
                  {service.title}
                </Typography>

                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  {service.highlights.map((item, i) => (
                    <Box
                      component="li"
                      key={i}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 3,
                      }}
                    >
                      <CheckCircleIcon
                        color="success"
                        sx={{ mr: 1, fontSize: 18 }}
                      />
                      {item}
                    </Box>
                  ))}
                </Box>
              </GlowCard>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Testimonials */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #f9fbfe 0%, #e8f4ff 100%)",
          py: 10,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            fontWeight="bold"
            textAlign="center"
            sx={{ color: "#000ca4", mb: 6 }}
          >
            What Industry Leaders Say
          </Typography>

          <Grid container spacing={4}>
            {testimonials.map((testimonial, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card
                  sx={{
                    p: 4,
                    borderRadius: 4,

                    boxShadow: "0 10px 30px rgba(0, 12, 164, 0.1)",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                    <Avatar
                      src={testimonial.avatar}
                      sx={{
                        width: 60,
                        height: 60,
                        mr: 3,
                        border: "2px solid #2DEB9C",
                      }}
                    />
                    <Box>
                      <Typography variant="h6" fontWeight="bold">
                        {testimonial.name}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        {testimonial.role}
                      </Typography>
                    </Box>
                  </Box>

                  <Typography variant="body1" fontStyle="italic">
                    "{testimonial.feedback}"
                  </Typography>
                  <Box sx={{ display: "flex", mt: 2 }}>
                    {[...Array(5)].map((_, i) => (
                      <span
                        key={i}
                        style={{ color: "#FFD700", fontSize: "1.2rem" }}
                      >
                        ★
                      </span>
                    ))}
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          background: `linear-gradient(rgba(0, 12, 164, 0.9), url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          py: { xs: 10, md: 12 },
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <Chip
            label="READY TO TRANSFORM?"
            color="primary"
            sx={{
              mb: 3,
              px: 2,
              py: 2,
              fontWeight: "bold",
              background: "rgba(0, 50, 29, 0.3)",
              border: "1px solid #2DEB9C",
              color: "white",
            }}
          />
          <Typography
            variant={isMobile ? "h4" : "h2"}
            fontWeight="bold"
            gutterBottom
            sx={{
              color: "#002cb4",
              letterSpacing: 2,
            }}
          >
            Let's Build Something Extraordinary
          </Typography>

          <Typography
            variant="h6"
            sx={{
              mb: 4,
              color: "black",
              fontWeight: 600,
              maxWidth: "600px",
              
            }}
          >
            Schedule a free 30-minute consultation with our IT strategists
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              background: "linear-gradient(90deg, #2DEB9C, #84F4EE)",
              borderRadius: "30px",
              px: 6,
              py: 1.5,
              fontWeight: "bold",
              fontSize: "1.1rem",
              boxShadow: "0 4px 20px rgba(45, 235, 156, 0.5)",
            }}
            onClick={() => navigate("/contact")}
          >
            Book Discovery Call
          </Button>
        </Container>
      </Box>
    </Box>
  );
};

export default ViewMore;
